import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  home: "/",
  winningAds: "/winning-ads",
  findProduct: "/find-product",
  orders: "/orders",
  sampleOrders: "/sample-orders",
  customization: "/customization",
  importList: "/import-list",
  promoReviews: "/reviewspro",
  liveProducts: "/live-products",
  branding: "/branding",
  brandedInvoice: "/branded-invoice",
  cancel: "/cancel",
};
